<template>
  <span class="range-slider" :class="{ disabled }">
    <drag-helper
      :disabled="disabled"
      @dragstart="dragStart"
      @drag="drag"
      @dragend="dragEnd"
    >
      <span ref="inner" class="range-slider-inner">
        <input
          class="range-slider-hidden"
          type="text"
          :name="name"
          :value="actualValue"
          :disabled="disabled"
        />
        <span class="range-slider-rail"></span>
        <span
          class="range-slider-fill"
          :style="{ width: valuePercent + '%' }"
        ></span>
        <span
          class="range-slider-knob"
          ref="knob"
          :style="{ left: valuePercent + '%' }"
        >
          <slot name="knob"></slot>
        </span>
      </span>
    </drag-helper>
  </span>
</template>

<script>
import DragHelper from './DragHelper'
import { round } from './utils'

export default {
  name: 'RangeSlider',
  components: {
    DragHelper
  },
  props: {
    name: String,
    modelValue: [String, Number],
    disabled: {
      type: Boolean,
      default: false
    },
    min: {
      type: [String, Number],
      default: 0
    },
    max: {
      type: [String, Number],
      default: 100
    },
    step: {
      type: [String, Number],
      default: 1
    }
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      actualValue: null,
      dragStartValue: null
    }
  },
  computed: {
    _min() {
      return Number(this.min)
    },
    _max() {
      return Number(this.max)
    },
    _step() {
      return Number(this.step)
    },
    valuePercent() {
      const min = this._min
      const max = this._max
      return (100 * (this.actualValue - min)) / (max - min)
    }
  },
  created() {
    const min = this._min
    const max = this._max
    let defaultValue = Number(this.modelValue)

    if (this.modelValue == null || isNaN(defaultValue)) {
      defaultValue = min > max ? min : (min + max) / 2
    }

    this.actualValue = this.validateValue(defaultValue)
    this.$emit('update:modelValue', this.actualValue)
  },
  watch: {
    modelValue(val) {
      this.actualValue = this.validateValue(val)
    }
  },
  methods: {
    validateValue(val) {
      const min = this._min
      const max = this._max
      const step = this._step
      return round(Math.min(max, Math.max(min, val)), step)
    },
    dragStart() {
      this.dragStartValue = this.actualValue
    },
    drag({ offsetX }) {
      const { width } = this.$refs.inner.getBoundingClientRect()
      const min = this._min
      const max = this._max
      const step = this._step
      const value = min + ((max - min) * offsetX) / width
      const newValue = round(value, step)
      this.actualValue = newValue
      this.$emit('update:modelValue', newValue)
    },
    dragEnd() {
      this.dragStartValue = null
      this.$emit('change', this.actualValue)
    }
  }
}
</script>
